import classNames from 'classnames';
import { useStocksQuery } from 'components/Stock/Stock.hooks';
import { useField } from 'formik';
import { useCallback, useMemo } from 'react';
import Select from 'react-select';
import './OpinionSymbolSelect.css';

export type OpinionSymbolSelectProps = {
  className?: string;
  isDisabled?: boolean;
}

export const OpinionSymbolSelect = ({ className, isDisabled }: OpinionSymbolSelectProps) => {
  const [, , helpers] = useField('symbol');
  const { data } = useStocksQuery();
  const options = useMemo(() => {
    const sorted = data.sort((a, b) => b.marketCap - a.marketCap);
    const krOptions = sorted.filter(stock => stock.country === 'kr').map(stock => ({ value: stock.symbol, label: stock.krShortName }));
    const usOptions = sorted.filter(stock => stock.country === 'us').map(stock => ({ value: stock.symbol, label: stock.krShortName }));
    return [
      { label: '선택안함', value: null },
      { label: '한국', options: krOptions },
      { label: '미국', options: usOptions },
    ];
  }, [data]);
  const onChange = useCallback(({ value }) => {
    helpers.setValue(value);
  }, [helpers]);

  return (
    <Select
      className={classNames('opinion-stock-select', className)}
      placeholder="종목"
      onChange={onChange}
      noOptionsMessage={() => "결과 없음"}
      isDisabled={isDisabled}
      options={options}
    />
  );
};
